import { jsxs as f, jsx as l } from "react/jsx-runtime";
import { E as s, S as p } from "./icons.types-0722eef5.js";
function u({ title: e, titleId: d, size: c, width: o, height: n, extended: a = !1, ...v }) {
  const i = a ? s : p, h = c ? i[c] : o || i[a ? "s" : "l"], t = c ? i[c] : n || i[a ? "s" : "l"];
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: h,
      height: t,
      "aria-labelledby": d,
      ...v,
      children: [
        e ? /* @__PURE__ */ l("title", { id: d, children: e }) : null,
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#1B75BB",
            d: "M4 28h64v16H4V28Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M58 14H14C7.373 14 4 18.925 4 25v4h64v-4c0-6.075-3.373-11-10-11Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M4 47c0 6.075 3.373 11 10 11h44c6.627 0 10-4.925 10-11v-3H4v3Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            fillRule: "evenodd",
            d: "M30.976 30.702c-.048-1.714-.104-3.427-.247-5.134-.014-.182-.081-.21-.242-.21-1.563.006-3.126.004-4.689.004l-11.312-.002c-.158 0-.263.002-.273.213-.042.894-.105 1.786-.154 2.678a99.012 99.012 0 0 0-.121 4.513c-.015 1.479-.1 2.958.172 4.428.256 1.391.735 2.699 1.51 3.891.312.564.715 1.064 1.14 1.547 1.561 1.78 3.499 3.045 5.602 4.086a.24.24 0 0 0 .232-.002c1.896-.938 3.662-2.063 5.144-3.592.6-.617 1.156-1.271 1.586-2.02 1.134-1.771 1.673-3.719 1.697-5.808.012-1.532 0-3.063-.045-4.592Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#ED1C25",
            fillRule: "evenodd",
            d: "M16.349 40.29c-.692-1.063-1.118-2.229-1.351-3.474-.241-1.309-.164-2.63-.152-3.948.007-1.34.043-2.681.109-4.02.043-.799.1-1.594.136-2.392.011-.187.105-.188.245-.188l10.09.002c1.397 0 2.791.002 4.186-.004.146 0 .204.026.217.187.127 1.525.178 3.053.221 4.582.04 1.364.053 2.729.038 4.094-.021 1.865-.504 3.604-1.515 5.184-.128-.053-.171-.179-.241-.282a3.6 3.6 0 0 0-.786-.848c-.626-.473-1.61-.341-2.166.172a2.993 2.993 0 0 0-.348.377c-.122.162-.175.156-.264-.021a5.303 5.303 0 0 0-.78-1.192 2.7 2.7 0 0 0-.668-.553c-.091-.053-.19-.091-.223-.206-.041-.438-.013-.88-.019-1.319-.006-.485-.006-.97 0-1.454.002-.275.055-.338.332-.324 1.139.049 2.281.053 3.392.371.23.064.238.048.227-.189-.023-.53-.022-1.059.002-1.588.01-.215-.004-.24-.221-.18-.822.219-1.67.332-2.52.336-.268.002-.533.053-.803.034-.34-.021-.409-.087-.411-.417-.002-.492-.004-.986.002-1.477.002-.296.073-.349.364-.336.865.042 1.725.127 2.561.374.15.045.209-.01.207-.159-.004-.12.016-.24-.01-.357-.071-.371-.003-.743.006-1.115.014-.386.008-.385-.356-.293-.705.175-1.416.305-2.144.293-.099-.002-.192.02-.289.029-.264.027-.347-.038-.337-.308.015-.351.061-.7.107-1.045.06-.437.134-.871.223-1.301.053-.259.019-.308-.232-.279-.483.054-.97.054-1.452 0-.237-.026-.262.009-.217.241.151.785.289 1.57.332 2.369.014.238-.047.333-.251.324-.691-.035-1.386-.055-2.064-.219-.203-.051-.411-.084-.609-.151-.132-.046-.188-.021-.185.134a42.68 42.68 0 0 1 0 1.701c-.004.15.047.185.185.141.84-.271 1.711-.324 2.582-.379.275-.017.365.066.369.346.006.507.006 1.014 0 1.521-.004.26-.065.322-.33.356a1.9 1.9 0 0 1-.268.009c-1.058-.043-2.115-.08-3.147-.367-.211-.059-.243-.037-.231.18.019.528.019 1.057 0 1.586-.012.221.032.24.255.181a9.8 9.8 0 0 1 2.498-.323c.31 0 .611-.06.916-.043.218.012.302.074.302.277.006.938.028 1.877-.011 2.815-.021.091-.091.132-.166.169-.486.248-.834.642-1.13 1.089a5 5 0 0 0-.377.657c-.1.212-.168.221-.308.027-.286-.389-.648-.646-1.123-.754-.715-.164-1.288.076-1.768.594-.18.2-.342.414-.484.641-.037.055-.07.113-.149.117",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#1B75BB",
            fillRule: "evenodd",
            d: "M16.349 40.29c.195-.279.381-.566.608-.822.986-1.094 2.408-.65 2.967.205.031.047.065.097.112.16.411-.848.885-1.623 1.768-2.041.313-.259 1.05-.256 1.333.003.871.419 1.345 1.187 1.744 2.02.085-.037.105-.113.146-.17.584-.84 1.933-1.197 2.841-.277.277.285.513.599.707.942-.386.669-.878 1.253-1.414 1.805-1.323 1.365-2.897 2.37-4.591 3.206-.074.035-.131.037-.204 0-1.878-.926-3.609-2.058-5-3.646-.38-.43-.738-.876-1.014-1.382",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            fillRule: "evenodd",
            d: "M23.14 37.796a1.85 1.85 0 0 0-1.333-.003c-.002-.932-.012-1.865-.002-2.797.002-.196-.036-.268-.253-.264-1.231.02-2.457.063-3.648.43-.021.008-.046 0-.087 0 .019-.611.049-1.221.015-1.833-.022-.405-.013-.411.378-.308 1.11.3 2.249.346 3.392.336.144-.002.208-.034.204-.198-.01-.56-.01-1.12 0-1.679.002-.162-.053-.199-.204-.197-.942.022-1.874.117-2.775.405-.166.053-.183.019-.174-.142.04-.631.042-1.266-.002-1.898-.013-.178.034-.182.184-.136.901.284 1.832.39 2.775.403.144 0 .192-.032.181-.19-.063-.856-.188-1.7-.371-2.54-.04-.178-.01-.234.179-.211a8.503 8.503 0 0 0 1.786 0c.14-.014.177.008.144.164-.183.837-.31 1.686-.378 2.541-.015.184.03.24.223.236.938-.021 1.859-.125 2.755-.409.136-.044.166-.015.159.12-.038.65-.038 1.298 0 1.946.007.138-.021.161-.159.119-.896-.286-1.819-.381-2.755-.409-.187-.006-.235.049-.231.234.013.55.009 1.104 0 1.654-.002.131.028.182.172.184 1.218.018 2.43-.037 3.606-.389.164-.047.221-.051.204.148a10.998 10.998 0 0 0 0 1.879c.01.145 0 .195-.174.145-1.193-.354-2.419-.396-3.654-.404-.164 0-.152.09-.152.199l-.005 2.864Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
export {
  u as SvkSlovakia
};
